import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import UpdateClassForm from "../Forms/UpdateClassForm";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
class UpdateClassModal extends React.Component {
  render() {
    var className = this.props.classToUpdate
      ? this.props.classToUpdate.name
      : "";
    return (
      <Modal
        style={{ maxWidth: "700px", width: "80%" }}
        isOpen={this.props.isOpen}
        toggle={this.props.toggle}
      >
        <ModalHeader>
          <FontAwesomeIcon icon="edit" />
          &nbsp; Uppdatera {className}
        </ModalHeader>
        <ModalBody>
          <UpdateClassForm
            classToUpdate={this.props.classToUpdate}
            teacherSelection={this.props.teacherSelection}
            dismissModal={this.props.dismissModal}
            programmeSelection={this.props.programmeSelection}
            orientationSelection={this.props.orientationSelection}
            reloadAfterProceed={this.props.onProceed}
          />
        </ModalBody>
      </Modal>
    );
  }
}

export default UpdateClassModal;
